if (!customElements.get('product-fragrance-display')) {
  customElements.define(
    'product-fragrance-display',
    class ProductFragranceDisplay extends HTMLElement {
      constructor() {
        super();
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        try {
          this.fragranceMap = JSON.parse(this.dataset.map || '{}');
        } catch (e) {
          this.fragranceMap = {};
        }
        this.textEl = this.querySelector('.product-fragrance__text');

        const initialId = this.dataset.currentId;
        if (initialId) this.update(initialId);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const id = event?.data?.variant?.id;
          if (id) this.update(String(id));
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      update(variantId) {
        const value = this.fragranceMap[variantId];
        if (value && value.trim() !== '') {
          this.textEl.textContent = value;
          this.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    }
  );
}
